import React from 'react'

interface LockIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

const LockIcon: React.FC<LockIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 45 45"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      fill="none"
    >
      <g transform="scale(1.05)">
        <path
          d="M31.25 17.5H29.375V11.875C29.375 5.32813 24.0469 0 17.5 0C10.9531 0 5.625 5.32813 5.625 11.875V17.5H3.75C1.67969 17.5 0 19.1797 0 21.25V36.25C0 38.3203 1.67969 40 3.75 40H31.25C33.3203 40 35 38.3203 35 36.25V21.25C35 19.1797 33.3203 17.5 31.25 17.5ZM23.125 17.5H11.875V11.875C11.875 8.77344 14.3984 6.25 17.5 6.25C20.6016 6.25 23.125 8.77344 23.125 11.875V17.5Z"
          fill="black"
        />
      </g>
    </svg>
  )
}

export default LockIcon
